export const DONATED_BY = 'Donated by';
export const PICTURE = 'Picture';
